import { render, staticRenderFns } from "./listaProyectosAdmin.vue?vue&type=template&id=3668bc20"
import script from "./listaProyectosAdmin.vue?vue&type=script&lang=js"
export * from "./listaProyectosAdmin.vue?vue&type=script&lang=js"
import style0 from "./listaProyectosAdmin.vue?vue&type=style&index=0&id=3668bc20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports